import { Outlet } from 'react-router-dom';

const Auth = () => {
  return <Outlet />;
};

export default Auth;
